import React, { useState, useEffect } from "react";
import styles from "./subscription.module.css";
import { Link } from "react-router-dom";
import { FaRupeeSign } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import {
    handlePaymentSuccesscontacts,
    createRazorpayOrderContacts,
} from "../../Services/APIrequests";

const ProPlanTab = ({ data, redirect }) => {
    const navigate = useNavigate();
    const [razorpayOrderId, setRazorpayOrderId] = useState("");
    const [receiptId, setReceiptId] = useState("");
    const [selectedCard, setSelectedCard] = useState(null);
    const [credits, setCredits] = useState({});

    useEffect(() => {
        const initialCredits = {};
        data.forEach((plan) => {
            initialCredits[plan.id] = plan.minCredits || 10;
        });
        setCredits(initialCredits);
    }, [data]);

    const handleCreditsChange = (id, min, max, value) => {
        // if(min< Number(value) && max>Number(max)){

        // }
        setCredits((prev) => ({ ...prev, [id]: value }));
    };

    const handleSubscribe = async (
        razorpay_order_Id,
        razorpay_payment_id,
        credits
    ) => {
        try {
            const data2 = {
                razorpay_order_id: razorpay_order_Id,
                razorpay_payment_id: razorpay_payment_id,
                credits: credits,
            };

            const paymentCartDetailsApi1 = await handlePaymentSuccesscontacts(
                data2
            );

            if (paymentCartDetailsApi1.status === 200) {
                if (redirect) {
                    navigate(redirect);
                } else {
                    navigate("/SubscribeSuccessfully");
                }
            } else {
                alert(
                    paymentCartDetailsApi1.message ||
                        "Something went wrong while processing the subscription."
                );
            }
        } catch (error) {
            console.error("Error in handleSubscribe:", error);
            alert("An unexpected error occurred. Please try again.");
        }
    };

    const handlePayClick = async (e) => {
        e.preventDefault();
        const totalCredits = credits[selectedCard.id];
        try {
            const totalPrice =
                credits[selectedCard.id] * selectedCard.pricePerCredit * 1.18;

            const roundedAmount = parseFloat(totalPrice.toFixed(2));

            const paymentCartDetailsApi = await createRazorpayOrderContacts({
                amount: roundedAmount,
            });

            if (paymentCartDetailsApi.status === 201) {
                setRazorpayOrderId(
                    paymentCartDetailsApi.data.data.razorpay_orderId
                );
                setReceiptId(paymentCartDetailsApi.data.data.receiptId);
                const options = {
                    // key: "rzp_test_8fofedsVTbn7Vv", /*dev*/
                    key: process.env.REACT_APP_RAZORPAYKEY /*prod*/,
                    amount: totalPrice * 100,
                    currency: "INR",
                    name: "Kohere",
                    description: "Order Payments",
                    order_id: paymentCartDetailsApi.data.razorpay_orderId,
                    handler: function (response) {
                        if (response.razorpay_payment_id !== null) {
                            handleSubscribe(
                                paymentCartDetailsApi.data.data
                                    .razorpay_orderId,
                                response.razorpay_payment_id,
                                totalCredits
                            );
                        } else {
                            alert("Something went wrong, please try again.");
                        }
                    },
                    prefill: {
                        name: "kohere",
                        email: "kohere@gmail.com",
                        // contact: 9010234589,
                    },
                    notes: {
                        address: "",
                    },
                    theme: {
                        color: "#FDFBB9",
                    },
                };
                const rzp1 = new window.Razorpay(options);
                rzp1.open();
            }
        } catch (error) {
            console.error("Error:", error);
            alert("An error occurred while processing the payment.");
        }
    };

    const planDescriptions = [
        "No Commitment: Perfect for occasional needs. Straightforward: No hidden fees or contracts.",
        "Best For: Frequent users looking for steady access. No Limits: Use as many credits as you need.",
        "Best Value: Ideal for large teams or frequent users. Great for Teams: Designed for users who need large-scale reporting.",
        "Best For: Frequent users looking for steady access. No Limits: Use as many credits as you need.",
        "Best Value: Ideal for large teams or frequent users. Great for Teams: Designed for users who need large-scale reporting.",
    ];

    return (
        <form>
            {data && data.length > 0 ? (
                <>
                    <div className={styles.subscription_pageplans}>
                        <div className={styles.proPlanTabcardContainer}>
                            {data.map((plan, index) => (
                                <div
                                    key={plan.id}
                                    className={`${
                                        styles.subscription_pageplan
                                    } ${
                                        selectedCard?.id === plan.id
                                            ? styles.subscription_pageselected
                                            : ""
                                    }`}
                                    onClick={() =>
                                        setSelectedCard((prev) =>
                                            prev?.id === plan.id ? null : plan
                                        )
                                    }>
                                    <h3
                                        className={
                                            styles.subscription_Pay_desc
                                        }>
                                        <FaRupeeSign
                                            className={
                                                styles.subscription_Pay_icon
                                            }
                                        />
                                        {plan.pricePerCredit} Per company
                                    </h3>
                                    <p className={styles.subscription_Pay_para}>
                                        Number of Credits
                                    </p>
                                    <div className={styles.subscription_Pay}>
                                        <input
                                            type="number"
                                            value={credits[plan.id]}
                                            onChange={(e) =>
                                                handleCreditsChange(
                                                    plan.id,
                                                    plan.minCredits,
                                                    plan.maxCredits,
                                                    parseInt(e.target.value, 10)
                                                )
                                            }
                                            min={plan.minCredits}
                                            max={plan.maxCredits}
                                        />
                                    </div>
                                    <p>
                                        (Between {plan.minCredits} and{" "}
                                        {plan.maxCredits})
                                    </p>
                                    {(plan.minCredits >
                                        Number(credits[plan.id]) ||
                                        plan.maxCredits <
                                            Number(credits[plan.id])) && (
                                        <p style={{ color: "red" }}>
                                            value should be between{" "}
                                            {plan.minCredits} and{" "}
                                            {plan.maxCredits}
                                        </p>
                                    )}
                                    <p className={styles.subscription_Pay_para}>
                                        Start From{" "}
                                    </p>
                                    <h4>
                                        ₹
                                        {(
                                            plan.minCredits *
                                            plan.pricePerCredit
                                        ).toLocaleString("en-IN")}
                                    </h4>
                                    {/* Added line here */}
                                    <p
                                        style={{
                                            color: "red",
                                            fontSize: "12px",
                                        }}>
                                        * GST EXCLUDING
                                    </p>
                                    <p>{planDescriptions[index]}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {selectedCard && (
                        <div className={styles.subscription_pagefooter}>
                            <div className={styles.subscription_pagefooter1}>
                                <h3>{selectedCard.description}</h3>
                                <h2>
                                    ₹
                                    {(
                                        (credits[selectedCard.id] || 0) *
                                        selectedCard.pricePerCredit *
                                        1.18
                                    ).toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })}
                                </h2>
                                <p>18% GST included</p>
                            </div>
                            <div className={styles.subscription_pagefooter2}>
                                <button
                                    onClick={handlePayClick}
                                    disabled={
                                        (credits[selectedCard.id] || 0) <
                                            selectedCard.minCredits ||
                                        (credits[selectedCard.id] || 0) >
                                            selectedCard.maxCredits ||
                                        (credits[selectedCard.id] || 0) === 0
                                    }>
                                    Buy Now
                                </button>
                                <p>
                                    By subscribing or purchasing credits, you
                                    acknowledge our <br />
                                    <Link to="/Terms_Conditions">
                                        Terms of Service
                                    </Link>{" "}
                                    and{" "}
                                    <Link to="/Privacypolicy">
                                        Privacy Policy
                                    </Link>
                                    .
                                </p>
                            </div>
                        </div>
                    )}
                </>
            ) : (
                <p
                    style={{
                        padding: "2rem",
                        fontSize: "1.2rem",
                        color: "white",
                        textAlign: "center",
                    }}>
                    No current plans available.
                </p>
            )}
        </form>
    );
};

export default ProPlanTab;
